import { MailIndexBatchStatus } from 'services/mail'

export function MailIndexProgress({ batch }: { batch: MailIndexBatchStatus }) {
  const requests = batch.current_requests
  const errors = (requests.failed || 0) + (requests.unavailable || 0)
  const label = batch.enumeration_status === 'complete'
    ? !batch.settled ? 'Scansione conclusa, elaborazioni ancora pendenti' : errors ? 'Concluso con errori' : 'Concluso'
    : { acquiring: 'Acquisizione in corso', pending: 'In attesa', running: 'Scansione in corso', paused: 'Sospeso', failed: 'Concluso con errori' }[batch.enumeration_status]
  return <section aria-label="Avanzamento storico" className="space-y-1">
    <p>{label}</p>
    <p>{batch.scope_ready}/{batch.scope_eligible} email aggiornate nel perimetro</p>
    <p>{batch.remaining_to_enumerate} da esaminare</p>
    <p>In attesa: {requests.pending || 0}; in elaborazione: {requests.processing || 0}; da riprovare: {requests.retry_wait || 0}; in pausa: {requests.paused || 0}; errori: {errors}</p>
  </section>
}
